
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mailTemplates",
      function () {
        return require("private-next-pages/mailTemplates.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mailTemplates"])
      });
    }
  